import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { SelectSupplierInfo } from '../types/comp-block';

/**
 * SessionSelectedSuppliers 状态管理 store 接口定义
 */
interface SessionSelectedSuppliersStoreState {
  /**
   * key 为 sessionId，value 为 Record<subMessageId, SelectSupplierInfo>
   */
  sesstionSelectedSuppliers: Record<string, Record<string, SelectSupplierInfo>>;
  setSessionSelectedSuppliers: (sessionId: string, selectedSuppliers: Record<string, SelectSupplierInfo>) => void;
  getSessionSelectedSuppliers: (sessionId: string) => Record<string, SelectSupplierInfo>;
}

/**
 * 创建 SessionSelectedSuppliers 状态管理 store
 * @returns
 */
export const createSessionSelectedSuppliersStore = () => {
  return create<SessionSelectedSuppliersStoreState>()(
    immer((set, get) => {
      return {
        sesstionSelectedSuppliers: {},
        setSessionSelectedSuppliers: (sessionId, selectedSuppliers) => {
          set((prev: SessionSelectedSuppliersStoreState) => {
            prev.sesstionSelectedSuppliers[sessionId] = selectedSuppliers;
          });
        },
        getSessionSelectedSuppliers: sessionId => {
          return get().sesstionSelectedSuppliers[sessionId] || undefined;
        },
      };
    })
  );
};
export const useSessionSelectedSuppliersStore = createSessionSelectedSuppliersStore();
